<template>
  <Modal
    id="popup-historico-mensageria"
    :title="'Histórico de Mensageria'"
    :active="active"
    @update:active="$emit('update:active', $event)"
    @close="closeModal()"
    data-testId="message-history-popup"
  >
    <div v-if="!isLoading" class="center">
      <vs-tabs alignment="center" v-model="activeTab">
        <vs-tab label="Segurado"> </vs-tab>
        <vs-tab label="Corretora"> </vs-tab>
      </vs-tabs>
      <vs-table stripe :data="list">
        <template #thead>
          <vs-th> Data/Hora</vs-th>
          <vs-th> Código</vs-th>
          <vs-th> Canal</vs-th>
          <vs-th> Destinatário</vs-th>
          <vs-th> Status</vs-th>
          <vs-th> Log de erro</vs-th>
          <vs-th> Observação</vs-th>
          <vs-th> Ações</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.createdAt">
              {{ formatarData(tr.createdAt) }}
            </vs-td>

            <vs-td :data="tr.codigoMensagem">
              {{ tr.codigoMensagem }}
            </vs-td>

            <vs-td :data="tr.canal">
              {{ tr.canal }}
            </vs-td>

            <vs-td :data="tr.destinatario">
              {{ tr.destinatario }}
            </vs-td>

            <vs-td :data="hasError(tr)">
              <vs-chip :color="hasError(tr) ? 'danger' : 'success'">
                {{ hasError(tr) ? 'Erro' : 'Sucesso' }}
              </vs-chip>
            </vs-td>

            <vs-td v-if="hasError(tr)" :data="tr.historico">
              {{ tr.historico }}
            </vs-td>
            <vs-td v-else> </vs-td>

            <vs-td :data="tr.observacao">
              {{ tr.observacao }}
            </vs-td>
            <vs-td v-if="canShowResendButton">
              <vs-button
                @click="showResendConfirm(tr)"
                radius
                color="warning"
                icon="cached"
                type="filled"
                class="mr-2"
                v-tooltip="'Reenviar Mensagem'"
              />
            </vs-td>
            <vs-td v-else></vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </Modal>
</template>
<script>
import Modal from '@/components/Modal.vue';
import messagingApi from '../../services/messaging.api';
import { MESSAGING_SUCCESS_STATUS } from '../../utils/constants';

export default {
  name: 'ModalHistoricoMensageria',
  components: {
    Modal,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    dadosProposta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hasBeenActive: false,
      isLoading: false,
      historic: [],
      activeTab: 0,
      tabs: {
        0: 'SEGURADO',
        1: 'CORRETORA',
      },
    };
  },
  watch: {
    active: {
      immediate: true,
      async handler(newValue) {
        if (newValue && !this.hasBeenActive) {
          this.hasBeenActive = true;
          await this.getHistorico();
        }
      },
    },
  },
  computed: {
    list() {
      return this.historic.filter((item) => {
        return (
          item.tipoDestinatario &&
          item.tipoDestinatario.toUpperCase() === this.tabs[this.activeTab]
        );
      });
    },
    canShowResendButton() {
      return this.$can('Reenviar Mensageria', 'Cotações');
    },
  },
  methods: {
    closeModal() {
      this.$emit('update:active', false);
      this.$emit('close');
    },
    formatarData(data) {
      const dateObj = new Date(data);
      const dia = dateObj.getDate().toString().padStart(2, '0');
      const mes = (dateObj.getMonth() + 1).toString().padStart(2, '0');
      const ano = dateObj.getFullYear();
      const horas = dateObj.getHours().toString().padStart(2, '0');
      const minutos = dateObj.getMinutes().toString().padStart(2, '0');
      const segundos = dateObj.getSeconds().toString().padStart(2, '0');
      return `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`;
    },
    async getHistorico() {
      if (!this.dadosProposta || !this.dadosProposta.idApolice) {
        return;
      }
      this.isLoading = true;
      this.$vs.loading();
      try {
        this.historic = await messagingApi.getMessagingHistoryByPolicyId(
          this.dadosProposta.idApolice,
          this.dadosProposta.dadosCliente.idProspect,
        );
      } finally {
        this.$vs.loading.close();
        this.isLoading = false;
      }
    },
    hasError(history) {
      return !MESSAGING_SUCCESS_STATUS.includes(history.historico);
    },
    resendMessage(message) {
      this.$vs.loading();
      const payload = {
        messagingHistoryId: message.idMensageriaFilaHistorico,
        channel: message.canal,
        receiverType: message.tipoDestinatario,
      };
      messagingApi
        .resendMessaging(payload)
        .then((response) => {
          if (response.success) {
            this.$vs.notify({
              position: 'top-center',
              title: 'Sucesso',
              text: 'Mensagem reenviada com sucesso',
              color: 'success',
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Erro',
            text: err.message,
            color: 'danger',
          });
        })
        .finally(() => {
          this.$vs.loading.close();
          this.getHistorico();
        });
    },
    showResendConfirm(message) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: `Confirmar`,
        text: 'Tem certeza que deseja reenviar essa mensagem?',
        acceptText: 'Enviar',
        cancelText: 'Cancelar',
        style: 'z-index: 999999',
        accept: () => this.resendMessage(message),
      });
    },
  },
};
</script>
<style>
#popup-historico-mensageria {
  .vs-popup {
    width: 1000px !important;
    height: auto;
    min-height: 300px;
  }

  .vs-popup--content {
    width: auto !important;
    padding: 1rem;
    font-size: 1rem;
  }
}

.con-vs-dialog {
  z-index: 54000;
}

.tooltip {
  z-index: 54000;
}
</style>
